import React from 'react';
import { Textbox } from '../../components/inputs';

export default function ChangeDefaultPasswordForm(props) {
  const {
    newPassword,
    confirmPassword,
    setNewPassword,
    setConfirmPassword,
    missingRequired
  } = props;

  return (
    <>
      <Textbox
        fieldLabel="New Password"
        onChange={setNewPassword}
        currentValue={newPassword}
        isRequired
        error
        touched={missingRequired && !newPassword?.trim().length}
      />
      <Textbox
        fieldLabel="Confirm New Password"
        onChange={setConfirmPassword}
        currentValue={confirmPassword}
        isRequired
        error
        touched={missingRequired && !confirmPassword?.trim().length}
      />
    </>
  );
}
